var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenedEye(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76045 11.3677C7.18545 10.7937 6.83545 10.0137 6.83545 9.13866C6.83545 7.38566 8.24745 5.97266 9.99945 5.97266C10.8664 5.97266 11.6644 6.32366 12.2294 6.89766",
    stroke: "#425466",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1046 9.69922C12.8726 10.9892 11.8566 12.0072 10.5676 12.2412",
    stroke: "#425466",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65451 14.472C3.06751 13.226 1.72351 11.406 0.749512 9.13698C1.73351 6.85798 3.08651 5.02798 4.68351 3.77198C6.27051 2.51598 8.10151 1.83398 9.99951 1.83398C11.9085 1.83398 13.7385 2.52598 15.3355 3.79098",
    stroke: "#425466",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4475 5.99023C18.1355 6.90423 18.7405 7.95923 19.2495 9.13623C17.2825 13.6932 13.8065 16.4382 9.99953 16.4382C9.13653 16.4382 8.28553 16.2982 7.46753 16.0252",
    stroke: "#425466",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8868 1.25L2.11279 17.024",
    stroke: "#425466",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenedEye);
export default __webpack_public_path__ + "static/media/openedEye.5a103f1fe356dcf3a25452b395aa8460.svg";
export { ForwardRef as ReactComponent };